import { connect } from 'pwa-helpers/connect-mixin.js';
import { store } from '../../store/store.js';
import { initialize } from '../../store/env/env.js';
import { signedInExistingUser } from '../../store/auth/auth.js';

/**
 * Host integration shared by the `sdb-embedded-*` elements, this package's public API.
 *
 * A host (learning-leerplatform, or the SPA in apps/composition-player) passes
 * `.settings` and `.user`. The element feeds them into this package's own store and
 * stays empty until the environment is known, so the inner components can rely on
 * `state.env.settings` and `state.auth.user`. A `targetId` (catalog item id) is mapped
 * to the composition id the API expects.
 *
 * Subclasses render `nothing` while `!this.ready` and may narrow `isReady(state)`.
 */
export const EmbeddedHost = (base) => class extends connect(store)(base) {
    static properties = {
        settings: { type: Object },
        user: { type: Object },
        targetId: { type: String },
        compositionId: { type: String },
        ready: { state: true },
    };

    constructor() {
        super();

        this.ready = false;
    }

    connectedCallback() {
        super.connectedCallback();

        if (this.targetId) {
            this.compositionId = `COMP_${this.targetId.replace(/-/g, '')}`;
        }
    }

    /** The store state this element needs before it renders; extend in a subclass. */
    isReady(state) {
        return !state.env.loading && !!state.env.settings;
    }

    stateChanged(state) {
        this.ready = this.isReady(state);
    }

    /** The payload for the env slice's `initialize`; extend in a subclass. */
    environmentPayload() {
        return { settings: this.settings };
    }

    firstUpdated(changedProperties) {
        super.firstUpdated?.(changedProperties);

        if (this.settings) {
            store.dispatch(initialize(this.environmentPayload()));
        }
    }

    updated(changedProperties) {
        super.updated?.(changedProperties);

        if (changedProperties.has('user')) {
            store.dispatch(signedInExistingUser({ user: this.user }));
        }
    }
};
